// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    listStaffProfiles as listStaffProfilesAPI,
    
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { staffProfilesApiResponseError, staffProfilesApiResponseSuccess } from './actions';
import { StaffProfilesActionTypes } from './constants';

// const api = new APICore();



/**
 * List contactos
 */
function* listStaffProfiles() {
    try {
        const response = yield call(listStaffProfilesAPI);
        const listaEmpleados = response.data.data;
        
        yield put(staffProfilesApiResponseSuccess(StaffProfilesActionTypes.LIST_STAFF_PROFILES, listaEmpleados));
    } catch (error) {
        yield put(staffProfilesApiResponseError(StaffProfilesActionTypes.LIST_STAFF_PROFILES, error));
    }
}

export function* watchListStaffProfiles(): any {
    yield takeEvery(StaffProfilesActionTypes.LIST_STAFF_PROFILES, listStaffProfiles);
}


function* staffProfilesSaga(): any {
    yield all([
        fork(watchListStaffProfiles),
    ]);
}

export default staffProfilesSaga;
